
import { useEffect, useState } from "react";
import { getAllSuppliersApi } from "../../Services/SupplierService/SupplierService";
import { getAllCategoriesApi } from "../../Services/categoryService/CategoryService";
export const currencies : comboboxOption[] = [
  { optionId: 1, optionName: "United States Dollar (USD) $" },
  { optionId: 2, optionName: "Euro (EUR) €" },
  { optionId: 3, optionName: "British Pound Sterling (GBP) £" },
  { optionId: 4, optionName: "Japanese Yen (JPY) ¥" },
  { optionId: 5, optionName: "Australian Dollar (AUD) A$" },
  { optionId: 6, optionName: "Canadian Dollar (CAD) C$" },
  { optionId: 7, optionName: "Swiss Franc (CHF) CHF" },
  { optionId: 8, optionName: "Chinese Yuan (CNY) ¥" },
  { optionId: 9, optionName: "Swedish Krona (SEK) kr" },
  { optionId: 10, optionName: "New Zealand Dollar (NZD) NZ$" },
  { optionId: 11, optionName: "Mexican Peso (MXN) $" },
  { optionId: 12, optionName: "Singapore Dollar (SGD) S$" },
  { optionId: 13, optionName: "Hong Kong Dollar (HKD) HK$" },
  { optionId: 14, optionName: "Norwegian Krone (NOK) kr" },
  { optionId: 15, optionName: "South Korean Won (KRW) ₩" },
  { optionId: 16, optionName: "Turkish Lira (TRY) ₺" },
  { optionId: 17, optionName: "Indian Rupee (INR) ₹" },
  { optionId: 18, optionName: "Brazilian Real (BRL) R$" },
  { optionId: 19, optionName: "South African Rand (ZAR) R" },
  { optionId: 20, optionName: "Russian Ruble (RUB) ₽" },
  { optionId: 21, optionName: "Indonesian Rupiah (IDR) Rp" },
  { optionId: 22, optionName: "Malaysian Ringgit (MYR) RM" },
  { optionId: 23, optionName: "Thai Baht (THB) ฿" },
  { optionId: 24, optionName: "Philippine Peso (PHP) ₱" },
  { optionId: 25, optionName: "Polish Zloty (PLN) zł" },
  { optionId: 26, optionName: "Hungarian Forint (HUF) Ft" },
  { optionId: 27, optionName: "Czech Koruna (CZK) Kč" },
  { optionId: 28, optionName: "Israeli New Shekel (ILS) ₪" },
  { optionId: 29, optionName: "UAE Dirham (AED) د.إ" },
  { optionId: 30, optionName: "Saudi Riyal (SAR) ﷼" },
  { optionId: 31, optionName: "Egyptian Pound (EGP) £" },
  { optionId: 32, optionName: "Colombian Peso (COP) $" },
  { optionId: 33, optionName: "Peruvian Sol (PEN) S/." },
  { optionId: 34, optionName: "Vietnamese Dong (VND) ₫" },
  { optionId: 35, optionName: "Nigerian Naira (NGN) ₦" },
  { optionId: 36, optionName: "Kenyan Shilling (KES) Sh" },
  { optionId: 37, optionName: "Botswana Pula (BWP) P" },
  { optionId: 38, optionName: "Tanzanian Shilling (TZS) Sh" },
  { optionId: 39, optionName: "Sri Lankan Rupee (LKR) Rs" },
  { optionId: 40, optionName: "Bangladeshi Taka (BDT) ৳" },
];

export const invoiceTypes = ["Invoice", "Statement", "Receipt", "Credit Note", "Delivery Note", "Other"];
export const paymentMethods = ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Other"];
export const yesNo = ["Yes", "No"];



export type comboboxOption = {
  optionId: number | null;
  optionName: string;
};

// export type SupplierList = Supplier[];

export const loadSuppliers = async (): Promise<comboboxOption[]> => {
  try {
    const ress = await getAllSuppliersApi();

    const res = ress?.data?.data || ress?.data || ress || [];
    console.log("Suppliers loaded");
    console.log(res); 
    return Array.isArray(res)
      ? res.map((x: any) => ({
          optionName: x?.name ?? x?.Name ?? "",
          optionId: x?.supplierId ?? x?.SupplierId ?? null,
        })).filter((x: comboboxOption) => x.optionName)
      : [];
    return res
  } catch (err) {
    console.error("Failed to load suppliers", err);
    return [];
  }
};

export const loadCategories = async (): Promise<comboboxOption[]> => {
  try {
    const ress = await getAllCategoriesApi();

    const res = ress?.data?.data || ress?.data || ress || [];
    console.log("Categories loaded");
    console.log(res); 
    return Array.isArray(res)
      ? res.map((x: any) => ({
          optionName: x?.name ?? x?.Name ?? "",
          optionId: x?.categoryId ?? x?.CategoryId ?? null,
        })).filter((x: comboboxOption) => x.optionName)
      : [];
    return res
  } catch (err) {
    console.error("Failed to load categories", err);
    return [];
  }
};




